import React from "react";
import {
  Container,
  TextField,
  Tab,
  Tabs,
  createStyles,
  makeStyles,
  Button
} from "@material-ui/core";
import PageHero from "../PageHero";
import { useHistory, useParams } from "react-router-dom";
import TabPanel from "../TabPanel";
import DocumentPicker from "../Assignment/DocumentPicker";
import { Theme } from "react-autosuggest";
import { CompanyContext } from "../../context/CompanyContext";
import Document, { DocumentType } from "../../types/Document";
import TrainingSelectionViewer from "../Assignment/TrainingSelectionViewer";
import ButtonSpinner from "../ButtonSpinner";
import { Api } from "../../api";
import DocumentGroup from "../../types/DocumentGroup";
import { useSnackbar } from "notistack";

export default function AdminCreatePacket() {
  const history = useHistory();
  const companyContext = React.useContext(CompanyContext);
  const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);
  const [origIds, setOrigIds] = React.useState(Array<string>());
  const [docIds, setDocIds] = React.useState(Array<string>());
  const [docs, setDocs] = React.useState(Array<Document>());
  const [name, setName] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { packetId } = useParams();

  React.useEffect(() => {
    if (packetId) {
      Api.documentGroups.get(packetId).then(response => {
        if (!response.data?.hasError) {
          let packet = response.data?.data;
          if (packet) {
            setName(packet.groupName);
            setDocs(packet.documents);
            let ids: string[] = [];
            for (let doc of packet.documents) {
              ids.push(doc.documentId);
            }
            setOrigIds(ids);
            setDocIds(ids);
          }
        }
      });
    }
  }, [packetId, enqueueSnackbar]);

  function onDocumentSelected(doc: Document) {
    let id = doc.documentId;
    let idsArray = Array.from(docIds);
    let array = Array.from(docs);
    let index = idsArray.indexOf(id);
    if (index === -1) {
      array.push(doc);
      idsArray.push(id);
    } else {
      array.splice(index, 1);
      idsArray.splice(index, 1);
    }

    setDocs(array);
    setDocIds(idsArray);
  }

  function save() {
    setLoading(true);
    let request = {
      companyId: companyContext.companyId,
      groupName: name,
      documentIds: docIds
    } as DocumentGroup;
    if (packetId) request.groupId = packetId;
    Api.documentGroups
      .save(request)
      .then(response => {
        console.log(response);
        if (!response.data.hasError) {
          deleteDocuments();
        }
      })
      .finally(() => setLoading(false));
  }

  function deleteDocuments() {
    if (packetId) {
      let a = [];
      for (let id of origIds) {
        if (docIds.indexOf(id) === -1) {
          a.push(id);
        }
      }
      if (a.length > 0) {
        Api.documentGroups.deleteDocuments(packetId, a).then(() => {
          enqueueSnackbar("Packet saved successfully", {
            variant: "success"
          });
          history.goBack();
        });
      } else {
        enqueueSnackbar("Packet saved successfully", {
          variant: "success"
        });
        history.goBack();
      }
    } else {
      enqueueSnackbar("Packet saved successfully", {
        variant: "success"
      });
      history.goBack();
    }
  }

  return (
    <>
      <PageHero
        backhandler={() => history.goBack()}
        title="Packet"
        showBack={true}
      />
      <Container maxWidth="lg" style={{ padding: 30 }}>
        <TextField
          variant="outlined"
          label="Packet Name*"
          fullWidth
          value={name}
          onChange={event => setName(event.target.value)}
        />

        <h4 className={classes.header}>Documents</h4>

        <div className={classes.list}>
          <Tabs
            className="tabs-line"
            value={selectedTabIndex}
            style={{ marginBottom: 12 }}
          >
            <Tab
              label="Handbooks &amp; Manuals"
              className="tab"
              onClick={() => setSelectedTabIndex(0)}
            />
            <Tab
              label="Forms"
              className="tab"
              onClick={() => setSelectedTabIndex(1)}
            />
          </Tabs>
          <div className={classes.tabPanel}>
            <TabPanel value={selectedTabIndex} index={0}>
              <DocumentPicker
                companyId={companyContext.companyId}
                selectedDocumentIds={docIds}
                onDocumentSelected={onDocumentSelected}
                documentType={DocumentType.Handbook}
              />
            </TabPanel>
            <TabPanel value={selectedTabIndex} index={1}>
              <DocumentPicker
                companyId={companyContext.companyId}
                selectedDocumentIds={docIds}
                onDocumentSelected={onDocumentSelected}
                documentType={DocumentType.Form}
              />
            </TabPanel>
          </div>
        </div>
        <TrainingSelectionViewer
          training={[]}
          documents={docs}
          packets={[]}
          onRemoveTraining={() => {}}
          onRemoveDocument={onDocumentSelected}
          onRemovePacket={() => {}}
        />

        <div className="buttons-container">
          <Button
            variant="outlined"
            color="primary"
            onClick={() => history.goBack()}
            disabled={loading}
          >
            Cancel
          </Button>
          <ButtonSpinner
            variant="contained"
            color="primary"
            disabled={docs.length === 0 || name.length === 0}
            onClick={save}
            loading={loading}
          >
            Save
          </ButtonSpinner>
        </div>
      </Container>
    </>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tabPanel: {
      padding: "12px 12px 0 12px"
    },
    header: {
      textAlign: "center"
    },
    list: {
      width: "100%",
      margin: "0 auto",
      border: "1px solid #c9c9c9",
      borderRadius: 4
    },
    ul: {
      backgroundColor: "inherit",
      padding: 0
    }
  })
);
